import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { EcTerminalActionLogsModalComponent } from '../../../../shared/components/ec-terminal-action-logs-modal/ec-terminal-action-logs-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { EcReceiptPrintService } from '../../../worker/core/services/EcReceiptPrintService';
import { WorkerService } from '../../../worker/core/services/WorkerService';

@Component({
  selector: 'app-ec-terminal-actions-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    EcTerminalActionLogsModalComponent
  ],
  templateUrl: './ec-terminal-actions-modal.component.html',
  styleUrl: './ec-terminal-actions-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EcTerminalActionsModalComponent extends BaseModalComponent {

  @ViewChild(EcTerminalActionLogsModalComponent) ecTerminalActionLogsModalComponent: EcTerminalActionLogsModalComponent;

  private readonly _workerService = inject(WorkerService);
  private readonly _ecReceiptPrintService = inject(EcReceiptPrintService);

  public reconnectEcTerminal(): void {
    this._workerService.reconnectTerminal(this.terminalsStore.selectedTerminal().id, this.terminalsStore.selectedTerminal().currentSession?.id).subscribe({
      next: () => {
        this.notificationService.pushSuccess(
          'Erfolg'.trans('notifications/success.Title'),
          'Ec Terminal reconnected.'.trans(`reconnect-terminal/notifications/success.Message`)
        );
      },
      error: ({ error }: ApiErrorResponse) => {
        this.notificationService.pushError(
          'Fehler'.trans('notifications/error.Title'),
          error.message.trans(`reconnect-terminal/notifications/${error.message}.Message`)
        );
      }
    });
  }

  /**
   * Manual reprint of the buffered EC slip (legacy CXCash CDlgCXCash::PrintEC parity):
   * prompt for the customer copy, then forward the buffered slip to the POS/Epson printer.
   * The merchant copy is always printed by the worker.
   */
  public printEcReceipt(): void {
    this._ecReceiptPrintService.promptAndPrint(this.destroyRef, { showSuccessToast: true });
  }

  public endOfDay(): void {
    this.ecTerminalActionLogsModalComponent.open();

    this._workerService.endOfDay().subscribe({
      next: () => {
        this.notificationService.pushSuccess(
          'Erfolg'.trans('notifications/success.Title'),
          'End of Day completed successfully.'.trans(`end-of-day/notifications/success.Message`)
        );
      },
      error: ({ error }: ApiErrorResponse) => {
        this.ecTerminalActionLogsModalComponent.close();
        this.notificationService.pushError(
          'Fehler'.trans('notifications/error.Title'),
          error.message.trans(`end-of-day/notifications/${error.message}.Message`)
        );
      }
    });
  }
}
